// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Poll: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 38" enableBackground="new 0 0 38 38" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M33.58,0.25H4.42c-2.29,0-4.17,1.88-4.17,4.17v29.17c0,2.29,1.88,4.17,4.17,4.17
	h29.17c2.29,0,4.17-1.88,4.17-4.17V4.42C37.75,2.12,35.88,0.25,33.58,0.25z M12.75,29.42H8.58V14.83h4.17V29.42z M21.08,29.42h-4.17
	V8.58h4.17V29.42z M29.42,29.42h-4.17v-8.33h4.17V29.42z"/>
</svg>;
};

export default React.memo(Poll);
